// Firebase-brokered SSO for the instructor portal.
//
// Both Google and Microsoft sign-in go through Firebase Auth (signInWithPopup)
// and return a Firebase ID token. The backend endpoint
//   POST {REACT_APP_API_URL1}/api/user/google-login
// verifies that token with the Firebase Admin SDK when `isFirebaseLogin: true`
// is sent — the same code path for both providers.
//
// Firebase project: studyak-assistant-android (shared with the Flutter app).
// These config values ship in the client bundle and are NOT secret. They are
// overridable via REACT_APP_FIREBASE_* env vars to match the REACT_APP_* pattern
// used elsewhere in this app; the defaults are the known web-app values.

import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBfvq5oeSivy8TuK9RcaoaRxmubLIdChTg',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'studyak-assistant-android.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'studyak-assistant-android',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'studyak-assistant-android.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID || '127883279930',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:127883279930:web:bedf8841ace8368122ff03',
};

// Guard against re-initialization under hot-reload / repeated imports.
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

async function signInAndGetIdToken(provider) {
  // Always let the user pick an account rather than silently reusing the last one.
  provider.setCustomParameters({ prompt: 'select_account' });
  const result = await signInWithPopup(auth, provider);
  return result.user.getIdToken();
}

// Returns a Firebase ID token for a Google-authenticated user.
export function signInWithGoogle() {
  return signInAndGetIdToken(new GoogleAuthProvider());
}

// Returns a Firebase ID token for a Microsoft (Azure AD) -authenticated user.
export function signInWithMicrosoft() {
  const provider = new OAuthProvider('microsoft.com');
  // Some Azure tenants only return an email when it is explicitly requested.
  provider.addScope('email');
  return signInAndGetIdToken(provider);
}
